const { createTrialConversions } = require('../tracking/trial_conversions')
const { googleConsent, clearTrackingCookies } = require('./preferences')

const GA_ID = 'G-3XPZ7TFHTQ'
const ADS_ID = 'AW-11263388026'
const PIXEL_ID = '437549338268759'
const CONVERSIONS = {
  gtag_report_conversion: '6KG6CPjqpdsYEPrS5vop',
  gtag_report_conversion_pricing: 'Y13mCJuS6a4bEPrS5vop',
  gtag_report_conversion_plans: 'EXu4CPvqpdsYEPrS5vop',
  gtag_report_conversion_validated_form: 'p8qyCJ6S6a4bEPrS5vop',
  gtag_report_conversion_private_coaching: '3z7NCO-Ax7IbEPrS5vop',
  gtag_report_conversion_trial_confirmation: 'p8qyCJ6S6a4bEPrS5vop'
}

function createTracking(window, document, getPreferences, clarityProject, useGtm = false) {
  let googleLoaded = false
  let googleReady = false
  let pendingConversions = []
  let analyticsConfigured = false
  let adsConfigured = false
  let metaConfigured = false
  let metaLoaded = false
  let metaReady = false
  let clarityLoaded = false
  let clarityStopped = false
  let previous = null

  function script(id, src, onload) {
    if (document.getElementById(id)) return
    const element = document.createElement('script')
    element.id = id
    element.async = true
    element.src = src
    if (onload) element.onload = onload
    document.head.appendChild(element)
  }

  function conversion(label, url) {
    if (!getPreferences().advertising) return false
    if (!googleReady) {
      pendingConversions.push([label, url])
      return false
    }
    window.gtag('event', 'conversion', {
      send_to: ADS_ID + '/' + label,
      event_callback: function () {
        if (typeof url !== 'undefined') window.location = url
      }
    })
    return false
  }

  // Keep the existing inline callers and their conversion destinations intact.
  Object.keys(CONVERSIONS).forEach(name => {
    window[name] = function (url) { return conversion(CONVERSIONS[name], url) }
  })

  function initializeMeta() {
    if (!window.fbq) {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments)
        else fbq.queue.push(arguments)
      }
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = window._fbq = fbq
    }
    window.fbq('consent', 'grant')
    if (metaReady && !metaConfigured) {
      metaConfigured = true
      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }
    if (!metaLoaded) {
      metaLoaded = true
      script('smmart-meta-pixel', 'https://connect.facebook.net/en_US/fbevents.js', function () {
        metaReady = true
        if (getPreferences().advertising) initializeMeta()
        else window.fbq('consent', 'revoke')
      })
    }
  }

  function configureGoogle(value) {
    if (!googleReady) return
    if (value.analytics && !analyticsConfigured) {
      analyticsConfigured = true
      window.gtag('config', GA_ID, { groups: 'smmart_analytics' })
    }
    if (value.advertising && !adsConfigured) {
      adsConfigured = true
      window.gtag('config', ADS_ID, { groups: 'smmart_advertising' })
    }
  }

  function updateClarity(value) {
    if (!clarityProject) return
    if (value.analytics && !clarityLoaded) {
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments)
      }
      clarityLoaded = true
      // The consent command is queued before the remote library runs.
      window.clarity('consentv2', {
        analytics_Storage: 'granted',
        ad_Storage: value.advertising ? 'granted' : 'denied'
      })
      script('smmart-clarity', 'https://www.clarity.ms/tag/' + clarityProject)
    } else if (clarityLoaded) {
      if (!value.analytics && clarityStopped) return
      if (value.analytics && clarityStopped) {
        window.clarity('start')
        clarityStopped = false
      }
      window.clarity('consentv2', {
        analytics_Storage: value.analytics ? 'granted' : 'denied',
        ad_Storage: value.analytics && value.advertising ? 'granted' : 'denied'
      })
      if (!value.analytics && !clarityStopped) {
        // Denied consent alone would leave Clarity running without cookies.
        window.clarity('stop')
        clarityStopped = true
      }
    }
  }

  const trialConversions = createTrialConversions(window, document, getPreferences, conversion, useGtm)

  function apply(value) {
    trialConversions.apply(value)
    if (previous && ['analytics', 'advertising'].every(key => previous[key] === value[key])) return
    window['ga-disable-' + GA_ID] = !value.analytics
    window.gtag('consent', 'update', googleConsent(value))
    window.gtag('set', 'allow_google_signals', value.advertising)
    window.gtag('set', 'allow_ad_personalization_signals', value.advertising)

    if (value.analytics || value.advertising) {
      if (!googleLoaded) {
        googleLoaded = true
        window.gtag('js', new Date())
        script('smmart-google-tag', 'https://www.googletagmanager.com/gtag/js?id=' +
          (value.analytics ? GA_ID : ADS_ID), function () {
            googleReady = true
            // A visitor may have withdrawn consent while the script was downloading.
            configureGoogle(getPreferences())
            const pending = pendingConversions
            pendingConversions = []
            pending.forEach(args => conversion.apply(null, args))
          })
      }
      configureGoogle(value)
    }
    if (value.advertising) initializeMeta()
    else {
      pendingConversions = []
      if (window.fbq) window.fbq('consent', 'revoke')
    }
    updateClarity(value)
    clearTrackingCookies(document, window.location, value)
    previous = { analytics: value.analytics, advertising: value.advertising }
  }

  // These two conversions were in public GTM resource version 5. Observe only:
  // never preventDefault, submit a form, wait for tags or change link navigation.
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.closest && event.target.closest('#trialRegistrationModal, #coachingTrialRegistrationModal, #informationTrialRegistrationModal')) return
    conversion('5BaFCJ6cifUcEPrS5vop')
  })


  return { apply }
}

module.exports = { createTracking }
